var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9395 19.5499L16.6731 13.6037C16.7896 13.4829 16.8732 13.355 16.9239 13.22C16.9746 13.085 17 12.941 17 12.788C17 12.635 16.9746 12.4909 16.9239 12.3559C16.8732 12.221 16.7896 12.0931 16.6731 11.9723L10.9197 6.00559C10.7018 5.77961 10.4363 5.66663 10.1233 5.66663C9.81027 5.66663 9.54479 5.77961 9.32688 6.00559C9.10896 6.23158 9.0033 6.51033 9.0099 6.84181C9.01649 7.17328 9.12874 7.45201 9.34666 7.67801L14.274 12.788L9.32688 17.9185C9.10896 18.1445 9 18.4164 9 18.7342C9 19.052 9.10896 19.3239 9.32688 19.5499C9.54479 19.7759 9.81356 19.8888 10.1332 19.8888C10.4528 19.8888 10.7216 19.7759 10.9395 19.5499Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.c05bb500.svg";
export { ForwardRef as ReactComponent };